import { useEffect } from 'react';

interface SeoOptions {
  title: string;
  description?: string;
}

/**
 * 设置当前页面的 document.title 与 meta description。
 * 单页应用每页切换时更新 SEO 信息。
 */
export default function useSeo({ title, description }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
  }, [title, description]);
}